import { useEffect } from "react";

import { Actions, JobState, State } from "../types";

export const useJobLoader = (
  clearActiveJob: Actions["clearActiveJob"],
  loadJob: Actions["loadJob"],
  jobState: State["job"],
  jobId: string | undefined,
  loadRoles: Array<string>,
  review: boolean,
) => {
  useEffect(() => {
    if (!jobId) {
      if (jobState.state !== JobState.initial) {
        clearActiveJob();
      }
      return;
    }
    // check the situations where we need to start loading a new job
    if (
      jobState.state === JobState.initial ||
      (jobState.state === JobState.ready && jobState.job.id !== jobId) ||
      (jobState.state !== JobState.ready && jobState.jobId !== jobId)
    ) {
      loadJob(jobId, loadRoles, review);
    }
  }, [jobId, jobState.state, clearActiveJob, loadJob]);
};
